import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../../../../../models/api/apiTypes';

/*
 * Runtime types.
 */

export enum ContactsManagerSidePanelTypesEnum {
  ACCOUNT_DETAILS = 'ACCOUNT_DETAILS',
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  CREATE_CONTACT = 'CREATE_CONTACT',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  MERGE_CONTACTS = 'MERGE_CONTACTS',
}

export const RContactsManagerSidePanelStateBase = t.readonly(
  t.type({
    type: makeEnumRuntimeType(ContactsManagerSidePanelTypesEnum),
  }),
);
